import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";

interface Payload {
  token?: string;
  jobId?: string,
  talents?: any
}

const savePendingJobsFeedback = async (
  props: Payload,
) => {
  const url = `${END_POINT.BASE_URL}/v1/job/feedback`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const data: Payload = {
    jobId: props.jobId,
    talents: props.talents
  };
  const res = await axios.post(url, data, config);
  return res;
};

export const useSavePendingJobsFeedback = () => {
  return useMutation(savePendingJobsFeedback);
};
